import { getCookie } from '@/utils/auth'

export function TITLE() {
  // let name = getCookie('shopName') == '**' ? '**项目供应链ERP系统' : 'TransECS'
  let name = 'TransECS'
  const TITLE = {
    title: name || 'ERP系统'
  }
  
  return TITLE
}



//////////////////
// WEBPACK FOOTER
// ./settings.js
// module id = null
// module chunks = 